import sdkInstanceProvider from "../sdk/sdkInstanceProvider";
import { noticeError } from "@src/helpers/monitoring";
import { EARLY_ACCESS_TO_NEW_IN_BENEFIT_TYPE } from "@src/client/navigation/constants";

const getEnableComplianceVariant = async loyaltySdk => {
  const config = await loyaltySdk.getConfig();
  const benefit = config?.benefits?.find(
    benefit => benefit.type === EARLY_ACCESS_TO_NEW_IN_BENEFIT_TYPE
  );
  return benefit?.metadata?.enableComplianceVariant ?? false;
};

export async function getLoyaltyDetails(isAuthenticated) {
  try {
    const loyaltySdk = await sdkInstanceProvider("loyalty");
    const { getCustomerTierId, getCustomerDetails } = loyaltySdk;
    const isLoyaltyAvailable = await loyaltySdk.isLoyaltyAvailable();
    const enableComplianceVariant =
      await getEnableComplianceVariant(loyaltySdk);

    if (!isAuthenticated) {
      return {
        consentStatus: null,
        customerTierId: null,
        tierNumber: null,
        tierName: null,
        enableComplianceVariant,
        isLoyaltyAvailable,
        loyaltySdk
      };
    }

    const customerTierId = await getCustomerTierId();
    const { consentStatus, tiers } = await getCustomerDetails();
    const currentTier = tiers?.find(tier => tier?.id === customerTierId);
    const { name: tierName = "", tierNumber = "" } = currentTier || {};

    return {
      consentStatus,
      customerTierId,
      enableComplianceVariant,
      isLoyaltyAvailable,
      loyaltySdk,
      tierName,
      tierNumber
    };
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      noticeError(error);
    }

    return {
      consentStatus: null,
      customerTierId: null,
      enableComplianceVariant: false,
      isLoyaltyAvailable: false,
      loyaltySdk: null
    };
  }
}
